import { formSignatureData } from './formSignatureData'
import { InjectedWallet } from 'models/InjectedWallet'

export type SignedTypedData = string

export interface RequestSignatureOptions {
  signerAddress: string
  provider: Required<InjectedWallet>['provider']
  nonce: string
  userId?: string
  chainId: number
}

export const requestSignature = async ({
  chainId,
  signerAddress,
  provider,
  nonce,
  userId,
}: RequestSignatureOptions) => {
  const msgParams = formSignatureData({
    chainId,
    signatureType: 'sign:link-wallet',
    userId,
    address: signerAddress,
    nonce,
  })

  msgParams.domain.chainId = chainId

  const response = await (provider.send('eth_signTypedData_v4', [
    signerAddress,
    JSON.stringify(msgParams),
  ]) as Promise<SignedTypedData | { result: SignedTypedData }>)

  // todo: check if response is always a string, previous coode access .result
  return typeof response === 'string' ? response : response.result
}
